/***************************************************************************************
* FileName      : Inquire.js
* Description   : 해와관리자 > 주문배송 > 배송현황 조회 페이지 
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2023.00.00
* Modifide Date : 
* Reference     : 
***************************************************************************************/

import {Row, Col, Button , Navbar, Nav, Container} from 'react-bootstrap';
import { useDeliveryStatusQuery , handleDeliverySearch } from '../../../api/hwadmin/orderAPI';
import React, { useState , useEffect } from 'react';

import DeliveryStatusView  from "./DeliveryStatus/DeliveryStatusView";

import { handleResetClick } from '../../components/Resetpage';
import SelectVendor from '../product/Component/SelectVendor';

function DeliveryStatus()
{
    // 현황 데이터
    const { data, error, isFetching } =  useDeliveryStatusQuery();
    
  
    // 선택한 수산상회 
    const [selectedVendor, setSelectedVendor] = useState({ id: null, name: "" });

 
    const [searchUrl, setSearchUrl] = useState('');

    const [searchOrder, setSearchOrder] = useState('');
    const [searchOption, setSearchOption] = useState('all');
    const [searchResults, setSearchResults] = useState([]);

    // 검색중 인지 확인
    const [searchConfirm, setSearchConfirm] = useState(false);
     
    //날짜 옵션 선택
    const [selectedDateType, setSelectedDateType] = useState('register');

    //날짜 시작일
    const [selectedStartDate, setSelectedStartDate] = useState('');

    //날짜 종료일
    const [selectedEndDate, setSelectedEndDate] = useState('');

    const [activeComponent, setActiveComponent] = useState("DeliveryStatusView");


    const [selectedStatus , setSelectStatus] = useState('');

    const handleButtonClick = (status) => {
        setSelectStatus(status);
    };

    useEffect(()=>{

        // console.log("selectedStatus");
        // console.log(selectedStatus);

        if(searchConfirm){
            onSearch();
        }
    },[selectedStatus])


    const onSearch = () => {
       
        handleDeliverySearch({
            searchOrder, 
            setSearchResults,
            setSearchUrl,
            searchOption,
            selectedDateType,
            selectedStartDate, 
            selectedEndDate,
            selectedStatus,
            selectedVendor
        });
        
        setSearchConfirm(true);

    };

    //날짜 옵션 선택
    const handleDateTypeChange = (event) => {
        setSelectedDateType(event.target.value);
    };
        
    // 날짜 값 변화
    const handleStartDateChange = (event) => {
        setSelectedStartDate(event.target.value);
    };
        
    const handleEndDateChange = (event) => {
        setSelectedEndDate(event.target.value);
    };


    return(
        <>
        <div className='mainContents'>
            <div className='page-tit'>
                <h2>배송현황</h2>
            </div>
         
            {/* 배송 현황 */}
            <section className='state-wrap'>
               <div className={`state-box ${selectedStatus === "" ? "selected" : ''}`}
                    onClick={() => handleButtonClick("")}>
                    <p className='tit'>전체</p>
                    {data ? (
                        <p className='dec'>{data.total_count && data.total_count}</p>
                    ) : (
                        <p>Loading...</p>
                    )}
                </div>
 
                <div className={`state-box ${selectedStatus === "출고준비중" ? "selected" : ''}`}
                    onClick={() => handleButtonClick("출고준비중")}>
                    <p className='tit'>출고준비중</p>
                    {data ? (
                        <p className='dec'>{data.delivery_ready_count && data.delivery_ready_count}</p>
                    ) : (
                        <p>Loading...</p>
                    )}
       
                </div>
        
                <div className={`state-box ${selectedStatus === "배송중" ? "selected" : ''}`}
                    onClick={() => handleButtonClick("배송중")}>
                    <p className='tit'>배송중</p>
                    {data ? (
                        <p className='dec'>{data.shipping_count && data.shipping_count}</p>
                    ) : (
                        <p>Loading...</p>
                    )}
                </div>
                <div className={`state-box ${selectedStatus === "배송완료" ? "selected" : ''}`}
                    onClick={() => handleButtonClick("배송완료")}>
                    <p className='tit'>배송완료</p>
                    {data ? (
                        <p className='dec'>{data.shipping_complete_count && data.shipping_complete_count}</p>
                    ) : (
                        <p>Loading...</p>
                    )}
 
                </div>
            </section>

            {/* 검색 */}
            <section className='McontentBox m-p0'>
                <div className='search-wrap'>
                    <div className='search-field word'>
                        <div> 
                            <b>검색어</b> 
                        </div>
                        <div>
                        <select className='mSelectBox mr6'  value={searchOption} onChange={(e) => setSearchOption(e.target.value)}>
                                <option value="all" selected="selected">전체</option>
                                <option value="OrderNumber">주문번호</option>
                                <option value="ProductName">상품명</option>
                                <option value="ProductNumber">상품번호</option>
                        </select>

                        <input type="text"
                                value={searchOrder}
                                onChange={(e) => setSearchOrder(e.target.value)}/> 

                        </div>   
                    </div>
                    <div className='search-field date'>
                        <div> 
                            <b>날짜</b> 
                        </div>
                        <div>
                            <select value={selectedDateType} onChange={handleDateTypeChange}>
                                <option value="paid_at">결제완료일</option>
                                <option value="shipped_at">출고완료일</option>

                            </select>
                            <input type="date" value={selectedStartDate} onChange={handleStartDateChange} />
                            <input type="date" value={selectedEndDate} onChange={handleEndDateChange} />   
                        </div>   
                    </div>
                 
                    <div className='search-field word'>
                        <div> 
                            <b>수산상회</b> 
                        </div>
                        <div>
                            <SelectVendor 
                                selectedVendor={selectedVendor}
                                setSelectedVendor={setSelectedVendor}
                                />  
                        </div>   
                    </div>

                </div>
          
                <div className='m-btn-wrap'>
                    <button className='m-btn' 
                        onClick={()=>handleResetClick('/admin/order/deliverystatus/' , setSearchConfirm)}>
                        초기화
                    </button>
                    <button className='m-btn m-btn-search' onClick={()=>{onSearch()}} >검색</button>
                </div>
            </section>    

            {/* 전체 */}
            {selectedStatus === "" && 
                <DeliveryStatusView 
                    searchConfirm={searchConfirm}
                    searchResults={searchResults} 
                    setSearchResults={setSearchResults}
                    selectedStatus={selectedStatus}/>}
            
            {/* 출고준비중 */}
            {selectedStatus === "출고준비중" && 
                <DeliveryStatusView 
                    searchConfirm={searchConfirm}
                    searchResults={searchResults}  
                    setSearchResults={setSearchResults}
                    selectedStatus={selectedStatus}/>}


            {/* 배송중  */}
            {selectedStatus === "배송중" && 
                 <DeliveryStatusView 
                    searchConfirm={searchConfirm}
                    searchResults={searchResults}  
                    setSearchResults={setSearchResults}
                    selectedStatus={selectedStatus}/>}

     
            {/* 배송완료 */}
            {selectedStatus === "배송완료" && 
                 <DeliveryStatusView 
                    searchConfirm={searchConfirm}
                    searchResults={searchResults}  
                    selectedStatus={selectedStatus}/>}
                
            </div>

        </>
    )
}

export default DeliveryStatus